export default __webpack_public_path__ + "static/SFMC-12a92c898591d82e743a1d2ae7535b80.jpg";